(function () {
  'use strict';

  var CM_TO_IN = 0.3937007874;
  var SINGLE_NUMBER_RE = /^\s*-?\d+(?:\.\d+)?\s*$/;
  var NUMERIC_RANGE_RE = /^\s*(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)\s*$/;

  function formatInch(value) {
    var inches = value * CM_TO_IN;
    var rounded = Math.round(inches * 10) / 10;
    return Number.isInteger(rounded) ? rounded.toFixed(0) : rounded.toFixed(1);
  }

  function convertCellValue(raw, unit) {
    if (raw == null || raw === '') return null;
    if (unit === 'cm') return raw;

    if (SINGLE_NUMBER_RE.test(raw)) {
      var n = parseFloat(raw);
      if (!isNaN(n)) return formatInch(n);
    }

    var rangeMatch = raw.match(NUMERIC_RANGE_RE);
    if (rangeMatch) {
      return formatInch(parseFloat(rangeMatch[1])) + '-' + formatInch(parseFloat(rangeMatch[2]));
    }

    return null;
  }

  function applyUnit(root, unit) {
    var cells = root.querySelectorAll('[data-cm]');
    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      var raw = cell.getAttribute('data-cm');
      var converted = convertCellValue(raw, unit);
      if (converted == null) continue;
      cell.textContent = converted;
    }
    root.setAttribute('data-current-unit', unit);
  }

  function setActiveButton(buttons, unit) {
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var isActive = btn.getAttribute('data-size-chart-unit') === unit;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  function initRoot(root) {
    if (root.dataset.sizeChartInitialised === '1') return;
    root.dataset.sizeChartInitialised = '1';

    var defaultUnit = root.getAttribute('data-default-unit') || 'cm';
    applyUnit(root, defaultUnit);

    var unitButtons = root.querySelectorAll('[data-size-chart-unit]');
    setActiveButton(unitButtons, defaultUnit);

    for (var i = 0; i < unitButtons.length; i++) {
      unitButtons[i].addEventListener('click', function (event) {
        var target = event.currentTarget;
        if (!target) return;
        var unit = target.getAttribute('data-size-chart-unit');
        if (!unit) return;
        applyUnit(root, unit);
        setActiveButton(unitButtons, unit);
      });
    }

    var gorgiasButtons = root.querySelectorAll('[data-size-chart-gorgias]');
    for (var j = 0; j < gorgiasButtons.length; j++) {
      gorgiasButtons[j].addEventListener('click', function (event) {
        var chat =
          (typeof window !== 'undefined' && window.GorgiasChat) ||
          (typeof window !== 'undefined' && window.Gorgias && window.Gorgias.chat) ||
          null;

        if (chat && typeof chat.open === 'function') {
          event.preventDefault();
          chat.open();
        }
      });
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-size-chart-root]');
    for (var i = 0; i < roots.length; i++) {
      initRoot(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-size-chart-root]')) {
          initRoot(node);
        } else if (node.querySelectorAll) {
          initAll(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
